import { render, staticRenderFns } from "./RequestPriceButton.vue?vue&type=template&id=3c3a1ffe&scoped=true"
import script from "./RequestPriceButton.vue?vue&type=script&lang=ts"
export * from "./RequestPriceButton.vue?vue&type=script&lang=ts"
import style0 from "./RequestPriceButton.vue?vue&type=style&index=0&id=3c3a1ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a1ffe",
  null
  
)

export default component.exports